<template>
    <div class="choose" v-loading="loading">
        <div class="choose-title">{{ $t('login.Organization') }}</div>
        <div class="line"></div>
        <div class="choose-main">
            <div class="choose-main-title">{{ $t('user.Enterprise') }}</div>
            <el-select
                v-model="tenantId"
                size="medium"
                :placeholder="$t('login.PleaseChooseOrganization')"
                @change="selectTenant"
            >
                <el-option
                    v-for="item in tenantList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
            </el-select>
        </div>
        <div class="choose-main">
            <div class="choose-main-title">{{ $t('user.Company') }}</div>
            <el-select
                v-model="companyId"
                size="medium"
                :placeholder="$t('login.PleaseChooseOrganization')"
            >
                <el-option
                    v-for="item in companyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
            </el-select>
        </div>
        <button class="login-btn" @click="handleLogin">
            {{ $t('common.Enter') }}
        </button>
        <div class="login-tips">
            <div>{{ $t('contract.Tips') }}:{{ $t('login.ToManageAndInitiateDocumentSigning') }}</div>
            <div>
                <span class="login-tips_color">www.isigntrust.com</span>
                {{ $t('login.OrWeChatMiniProgram') }} "<span class="login-tips_color">{{ $t('login.SignTrust') }}</span>"
            </div>
            <div>{{ $t('login.CustomerServiceHotline') }}: 400-886-2808</div>
        </div>
    </div>
</template>

<script>
import { checkIpAccess, checkTenantExpireTimeAndStatus, getCompanyList, loginUserSelectCompany } from '@/api/login'
import { Message } from 'element-ui'
import { storageGet, storageRemove, storageSet } from '@/utils'
import { storageKey } from '@/utils/config'
import { getUser } from '@/api/user'

export default {
    props: {
        tenantList: {
            type: Array,
            default: () => [],
        },
    },
    name: 'ChooseCompany',
    data () {
        return {
            tenantId: '',
            companyId: '',
            loading: false,
            companyList: []
        }
    },
    methods: {
        async getCompany () {
            this.loading = true;
            // 获取公司列表
            this.companyList = await getCompanyList()
            this.loading = false;

            if (this.companyList.length === 0) {
                Message.warning('暂无公司，请联系租户负责人')
                return
            }

            if (this.companyList.length === 1) {
                this.companyId = this.companyList[0].id;
                if (this.tenantList.length === 1) {
                    this.handleLogin();
                }
                return;
            }
            const loggedCompanyId = storageGet("login-company-id");
            const coIdList = this.companyList.map((item) => item.id);

            if (loggedCompanyId && coIdList.includes(loggedCompanyId)) {
                this.companyId = loggedCompanyId;
            } else {
                this.companyId = undefined;
            }
        },
        selectTenant() {
            const tenant = this.tenantList.find((item) => item.id === this.tenantId);

            storageSet(storageKey.tenant, tenant);
            this.getCompany();
        },
        async handleLogin () {
            if (!this.tenantId) return this.$message.warning('请选择公司')
            try {
                this.loading = true
                const sofId = this.tenantId === '165' ? '11' : '95'

                // 查询租户是否可用
                const checkStatus = await checkTenantExpireTimeAndStatus(this.tenantId)

                if (checkStatus !== true) {
                    this.loading = false
                    return
                }

                storageSet(storageKey.companyList, this.companyList)
                const company = this.companyList.find((item) => item.id === this.companyId);
                storageSet(storageKey.company, company);

                // 检查ip是否可以登录
                const isIpPass = await checkIpAccess();

                if (isIpPass !== true) {
                    this.loading = false;
                    return;
                }

                await this.$store.commit('setSofId', sofId)
                await this.$store.commit('setcoId', this.companyId)

                storageSet("login-company-id", this.companyId);
                storageSet("login-tenant-id", this.tenantId);

                const { data: userInfo } = await getUser();

                if (userInfo.language) {
                    let language = userInfo.language;
                    if (language === 'zh-cn') {
                        language = 'zh';
                    }
                    this.$i18n.locale = language;
                    localStorage.setItem("language", language);
                }

                this.$message.success('登录成功')
                this.$emit('loginSuccess')
                this.loading = false
                this.$router.replace('/')
            } catch (e) {
                console.error(e)
                this.loading = false
            }
            // const { success, realName, token, errorMessage, coId } =
            //   await loginUserSelectCompany({
            //     coId: this.tenantId,
            //     sofId,
            //     usrId: this.$store.getters.userId,
            //   });
            // if (success) {
            //   await this.$store.commit("setcoId", coId);
            //   await this.$store.commit("setToken", token);
            //   await this.$store.commit("setUserName", realName);
            //   this.$message.success("登录成功");
            //   this.$emit("loginSuccess");
            //   this.$router.replace("/");
            // } else {
            //   this.$message.error(errorMessage);
            // }
        },
    },
    created () {
        this.tenantId = this.tenantList[0].id
        if (this.tenantList.length > 1) {
            const loggedTenantId = storageGet("login-tenant-id");
            const tenantIdList = this.tenantList.map((item) => item.id);

            // 如果之前登录过所属企业，默认选择
            if (loggedTenantId && tenantIdList.includes(loggedTenantId)) {
                this.tenantId = loggedTenantId;
            }
        }
        this.selectTenant();
    },
}
</script>

<style scoped lang="scss">
@import "../style/LoginForm";

.choose {
    width: 100%;
    @include flex-box(flex-start, center, column);

    &-title {
        color: $color;
        font-size: 18px;
        font-family: $font-weight-5;
        font-weight: 500;
    }

    .line {
        margin-top: 13px;
        width: 118px;
        height: 1px;
        border: 1px solid $color;
    }

    &-main {
        margin-top: 20px;
        width: 100%;
        font-family: $font-weight-5;

        .el-select {
            font-family: $font-weight-5;
            color: #333333;
            width: 100%;
        }

        &-title {
            color: #585757;
            margin-bottom: 10px;
        }
    }

    &-main + &-main {
        margin-bottom: 20px;
    }
}

::v-deep(.el-input--medium .el-input__inner) {
    height: 46px;
    line-height: 46px;
}

::v-deep(.el-select-dropdown__item.hover, .el-select-dropdown__item:hover) {
    color: $color;
    background: $color;
    opacity: 0.3;
}

::v-deep(.el-select .el-input.is-focus .el-input__inner, .el-select
    .el-input__inner:focus) {
    border-color: $color;
}
</style>
